export const fastAPIURL = process.env.REACT_APP_FASTAPI_URL
export const mapboxAccessToken = process.env.REACT_APP_MAPBOX_TOKEN || "pk.eyJ1Ijoic2VhcmNoLW1hY2hpbmUtdXNlci0xIiwiYSI6ImNrb2E2YzZheDA2ZHoydnFxOG95cjNuMWoifQ.TXC7Q4hjr1nktFft_n0Eog"
export const mapboxFlag = 1 //0: not connect mapbox, 1:connect mapbox